import { ILeadRaw } from 'models/lead.model'
import { subscriptionsApi } from 'nove8/api'
import { GlobalError, ProcessingKey } from 'nove8/constants/root-constants'
import { getAxonUserData } from 'nove8/helpers/getAxonUserData'
import { WEBAPP_COHORT } from 'root-constants'
import { eventLogger } from 'services/eventLogger.service'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'
import { useZustandStore } from 'zustandGlobalStore'

export const updateLeadWithEmail = async ({
  email,
  successCallback,
  unsuccessfulCallback,
}: {
  email: string
  successCallback?: () => void
  unsuccessfulCallback?: () => void
}): Promise<void> => {
  useZustandStore
    .getState()
    .startProcessing(ProcessingKey.UPDATE_LEAD_WITH_EMAIL)

  const leadId = useZustandStore.getState().lead?.id || ''
  const cohort =
    useZustandStore.getState().lead?.cohort ||
    useZustandStore.getState().initialCohort
  const hasEmailConsent = useZustandSessionStore.getState().hasEmailConsent

  const updateResponse = await subscriptionsApi.updateLead(leadId, { email })

  if (!updateResponse.success) {
    useZustandStore.setState({ globalError: GlobalError.COMMON_ERROR })

    eventLogger.logEmailPageError({
      error: JSON.stringify(updateResponse.data),
    })

    if (unsuccessfulCallback) {
      unsuccessfulCallback()
    }
    useZustandStore
      .getState()
      .stopProcessing(ProcessingKey.UPDATE_LEAD_WITH_EMAIL)
    return
  }

  if (cohort !== WEBAPP_COHORT) {
    eventLogger.logEmailPageCompleted({
      email,
      hasEmailConsent,
    })
  }

  window.fbq('track', 'Lead', {}, { eventID: leadId })
  window.ttq?.identify?.({ email })
  window.ttq?.track?.('CompleteRegistration')
  window.snaptr?.('track', 'SIGN_UP', {
    user_email: email,
  })
  window.pintrk && window.pintrk('track', 'lead')
  window.axon &&
    window.axon('track', 'generate_lead', {
      user_data: getAxonUserData(leadId, email),
    })

  if (successCallback) {
    successCallback()
  }

  // Getting updated lead should not block success callback returning
  const updatedLeadResponse = await subscriptionsApi.getLead({ leadId, cohort })
  const lead: ILeadRaw = updatedLeadResponse.data

  useZustandStore.setState({ lead })
  useZustandGlobalLocalStore.setState((state) => ({
    previousLeadId: state.previousLeadId || lead.id,
  }))

  useZustandStore
    .getState()
    .stopProcessing(ProcessingKey.UPDATE_LEAD_WITH_EMAIL)
}
